import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";

import InputText from "../../helpers/InputText";
import InputDecimal from "../../helpers/InputDecimal";
import InputTextArea from "../../helpers/InputTextArea";
import InputChecbox from "../../helpers/InputCheckbox";

import PlTitle from "../../elements/PlTitle";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputComboGrupa from "../../helpers/InputComboGrupaE";
import InputPESEL from "../../helpers/InputPESEL";
import InputDate from "../../helpers/InputDate";
import InputPhone from "../../helpers/InputPhone";
import InputEmail from "../../helpers/InputEmail";
import InputCombo from "../../helpers/InputCombo";
import InputSearchKid from "../../helpers/InputSearchKid";
import InputPostCode from "../../helpers/InputPostCode";
import InputNIP from "../../helpers/InputNIP";

import back from "../../back.png";

function KidShow(props)
{

    const [errTab, setErrTab] = useState([]);  //z info od serwera..


    const [filterParam, setFilterParam] = useState({   

        id: props.row.id,

        d_imie_nazwisko:  '',
        r_imie_nazwisko:  '', 
        p_grupa_id: '_x_',
        archiwalne:  '0',

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
    });



    var def_op_select = 1;


    if(props.row.rodzice.length > 1)
        {
            if(props.row.rodzice[1].prowadzenie_salda == '1') def_op_select = 2;
        }

        console.log(props);

    const [row, setRowX] = useState({
       
        id: props.row.id,

        p_grupa_id: props.row.p_grupa_id,
        imie:  props.row.imie,        
        imie2:  props.row.imie2,    
        nazwisko: props.row.nazwisko,
        
        info_e: "",


        rdz1_id: props.row.rodzice[0].id,
        rdz1_imie: props.row.rodzice[0].imie,
        rdz1_nazwisko: props.row.rodzice[0].nazwisko,
        rdz1_email: props.row.rodzice[0].e_mail_kontakt,
        rdz1_telefon: props.row.rodzice[0].telefon_kontaktowy,
       
        rdz2_id: props.row.rodzice[1].id,
        rdz2_imie: props.row.rodzice[1].imie,
        rdz2_nazwisko: props.row.rodzice[1].nazwisko,
        rdz2_email: props.row.rodzice[1].e_mail_kontakt,
        rdz2_telefon: props.row.rodzice[1].telefon_kontaktowy,
       
        osoby_upowaznione: props.row.osoby_upowaznione,


    });
   

    return (

            <div className="view_content">


                    <form className="eForm bg_center">
                        <div className="mobile_form_tab form_tab">
                            <div className="form_tab_title">Informacje podstawowe:
 
                            </div>
                                             
                                    <div className="form_control">
                                                <div className="fieldName">Grupa:</div>
                                                <div className="fieldText">
                                                    {
                                                        props.grupy.map( (item, ix) => {
                                                            if(item['v']===row.p_grupa_id)
                                                            return <div>{item.title}</div>
                                                        } )
                                                    }
                                                </div>
                                    </div>

                                    <div className="form_control">
                                                <div className="fieldName">Imię:</div>
                                                <div className="fieldText">{row.imie} &nbsp;</div>
                                    </div>

                                    <div className="form_control">
                                                <div className="fieldName">Drugie imię: </div>
                                                <div className="fieldText">{row.imie2}&nbsp;</div>
                                    </div>

                                    <div className="form_control">
                                                <div className="fieldName">Nazwisko:</div>
                                                <div className="fieldText">{row.nazwisko}&nbsp;</div>
                                    </div>


                        </div>



                            <div className="form_tab">


                                    <div className="form_tab_title">Dane opiekun lub rodzica nr 1:

                                    </div>



 

                                    <div className="form_control">
                                                <div className="fieldName">Imie:</div>
                                                <div className="fieldText">{row.rdz1_imie} &nbsp;</div>
                                    </div> 

                                    <div className="form_control">
                                                <div className="fieldName">Nazwisko:</div>
                                                <div className="fieldText">{row.rdz1_nazwisko} &nbsp;</div>
                                    </div>

                                    <div className="form_control">
                                        <div className="fieldName">Nr dowodu</div>
                                        <div className="fieldText">{row.rdz1_nr_dowodu}  &nbsp;</div>
                                    </div>

                                    <div className="form_control">
                                                <div className="fieldName">Telefon (zalecane)</div>
                                                <div className="fieldText">{row.rdz1_telefon} &nbsp; </div>
                                    </div>

                                    <div className="form_control">
                                                <div className="fieldName">E-mail (zalecane)</div>
                                                <div className="fieldText">{row.rdz1_email} &nbsp;</div>
                                               
                                    </div>

                                    

                            </div>

                            {row.rdz2_imie.length>0 &&                        
                            <div className="form_tab">

                                                    

                                    <div className="form_tab_title">Dane opiekun lub rodzica nr 2 (jeśli nie ma wpisz BRAK):

                                    </div>





                                    <div className="form_control">
                                                <div className="fieldName">Imię</div>
                                                <div className="fieldText">{row.rdz2_imie} &nbsp;</div>
                                    </div> 

                                    <div className="form_control">
                                                <div className="fieldName">Nazwisko</div>
                                                <div className="fieldText">{row.rdz2_nazwisko} &nbsp;</div>
                                    </div>


                                    <div className="form_control">
                                                <div className="fieldName">Telefon (zalecane)</div>
                                                <div className="fieldText">{row.rdz2_telefon} &nbsp;</div>
                                    </div>

                                    <div className="form_control">
                                                <div className="fieldName">E-mail (zalecane)</div>
                                                <div className="fieldText">{row.rdz2_email} &nbsp;</div>
                                    </div>

                                    <div className="form_control">
                                                <div className="fieldName">Nr dowodu</div>
                                                <div className="fieldText">{row.rdz2_nr_dowodu} &nbsp;</div>
                                    </div>


                            </div>
                            }
                            
                            <div className="form_tab">


                                    <div className="form_tab_title">Osoby upoważnione do odbioru dziecka

                                  

                                    </div>


                                    
                                    <div>
                                            <div className="form_split"></div>

                                        {
                                            row.osoby_upowaznione.map( (osb, rI) => {
                                                                        
                                                if(osb.id>0)
                                                {
                                                    return <div>
                                                        <div className="form_control">
                                                            <div className="fieldName">Imię</div>
                                                            <div className=' '>{osb.imie} &nbsp;</div>
                                                        </div> 

                                                        <div className="form_control">
                                                            <div className="fieldName">Nazwisko</div>
                                                            <div className=' '>{osb.nazwisko} &nbsp;</div>
                                                        </div>

                                                        <div className="form_control">
                                                            <div className="fieldName">Pokrewieństwo</div>
                                                            <div className=' '>{osb.stopien_pokrewienstwa} &nbsp;</div>
                                                        </div>

                                                         <div className="form_control">
                                                            <div className="fieldName">4 ostatnie znaki dowodu</div>
                                                            <div className=' '>{osb.nr_dowodu_4_ost_znaki} &nbsp;</div>
                                                        </div>
                                                    </div>
                                                }
                                                else
                                                {
                                                    return <div>Brak</div>
                                                }
                                                
                                                
                                            } )
                                        }
                                            
                                    </div>
                                    

                            </div>





                            <div className="form_tab">


                                    <div className="form_tab_title">Informacje dodatkowe:
                                    </div>

                                    <div className="form_control">
                                                       
                                                        <div>{row.info_e}</div>
                                                        
                                            </div>



                                    


 

                            </div>





                            




 

                            <div className="form_split"></div>

                            <div className="form_btn">
                                    <div className="btn btn_back" onClick={props.onBack}    > wróć</div>
                            </div>




                    </form>


            </div>
    )

}


export default KidShow;


